// Pure ranking helpers (unit-tested in test/ranking.test.ts).

export interface RankingEntry {
  id: string;
  name: string;
  score: number;
}

export type Outcome = { kind: "tie" } | { kind: "you" } | { kind: "winner"; name: string };

/** Same order the server uses for game_over: score desc, then name. */
export function rankPlayers(players: Iterable<RankingEntry>): RankingEntry[] {
  return [...players]
    .map(({ id, name, score }) => ({ id, name, score }))
    .sort((a, b) => b.score - a.score || a.name.localeCompare(b.name));
}

/** Competition ranking: ties share a position and the next one skips (1, 1, 3). */
export function positions(ranking: RankingEntry[]): number[] {
  return ranking.map((entry) => 1 + ranking.filter((r) => r.score > entry.score).length);
}

export function outcome(ranking: RankingEntry[], you: string): Outcome {
  const top = ranking[0];
  const leaders = top ? ranking.filter((r) => r.score === top.score) : [];
  if (leaders.length !== 1) return { kind: "tie" };
  const winner = leaders[0]!;
  return winner.id === you ? { kind: "you" } : { kind: "winner", name: winner.name };
}
